
import { toast } from "sonner";

export async function processVoiceInput(
  voiceRecording: any,
  userInput: string,
  preferredLanguage: string
): Promise<string> {
  if (voiceRecording.recordedAudioRef.current && (!userInput || userInput.trim() === '')) {
    console.log("📝 Traitement de l'entrée vocale...");
    
    try {
      const transcribedText = await voiceRecording.processVoiceInput(
        voiceRecording.recordedAudioRef.current, 
        preferredLanguage
      );
      
      if (transcribedText) {
        console.log("✅ Transcription réussie:", transcribedText.substring(0, 50) + "...");
        return transcribedText;
      } else {
        toast.error("Impossible de transcrire l'audio. Veuillez réessayer.");
        throw new Error("Transcription failed");
      }
    } catch (error) {
      console.error("❌ Erreur transcription audio:", error);
      toast.error("Erreur lors de la transcription audio");
      throw error;
    }
  }
  
  return userInput;
}

export async function handleImageProcessing(selectedImage: any): Promise<string | null> {
  if (!selectedImage) return null;
  
  try {
    const imageDataUrl = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target?.result as string);
      reader.onerror = () => reject(new Error("Erreur lecture image"));
      reader.readAsDataURL(selectedImage);
    });
    console.log("✅ Image convertie en data URL");
    return imageDataUrl;
  } catch (error) {
    console.error("❌ Erreur conversion image:", error);
    toast.error("Erreur lors du traitement de l'image.");
    throw error;
  }
}

export function handleAudioPlayback(
  autoVoiceResponse: boolean,
  audioPlayback: any,
  response: string,
  useElevenLabs: boolean,
  preferredLanguage: string
): void {
  if (autoVoiceResponse) {
    console.log("🎵 Génération audio activée...");
    
    setTimeout(async () => {
      try {
        await audioPlayback.playAudioResponse(
          response, 
          useElevenLabs,
          preferredLanguage
        );
      } catch (audioError) {
        console.error("❌ Erreur audio (non bloquante):", audioError);
        toast.warning("Service vocal temporairement indisponible", {
          description: "La réponse textuelle est disponible"
        });
      }
    }, 100);
  } else {
    console.log("🔇 Audio désactivé par l'utilisateur");
  }
}
